module.exports = __webpack_public_path__ + "2455e18571a998e56f84f573f30c1044.svg";